import { CircleCheckBigIcon, InfoIcon, Loader2Icon, CircleXIcon, TriangleAlertIcon } from "lucide-react";
import { Toaster as Sonner } from "sonner";

export const Toaster = ({ ...props }) => {
    return (
        <Sonner
            className="toaster group"
            icons={{
                success: <CircleCheckBigIcon className="size-5" />,
                info: <InfoIcon className="size-5" />,
                warning: <TriangleAlertIcon className="size-5" />,
                error: <CircleXIcon className="size-5" />,
                loading: <Loader2Icon className="size-5 animate-spin" />,
            }}
            style={{
                "--normal-bg": "var(--cm-p-surface)",
                "--normal-text": "var(--cm-p-text-primary)",
            }}
            toastOptions={{
                style: {
                    whiteSpace: "pre-line",
                },
                classNames: {
                    error: "cm-toast-error",
                    success: "cm-toast-success",
                },
            }}
            {...props}
        />
    );
};
